(function() {
  'use strict';

  angular
    .module('pub.home', [])
    .controller('HomeCtrl', HomeCtrl);

  /** @ngInject */
  function HomeCtrl($rootScope, $location, $state, API) {
    $rootScope.page = 'page';

    var vm = this;

    vm.openMod = function(){
      window.open(
        API.MOD_TOOLS,
        '_blank'
      );
    };

    vm.goToAccount = function (){
        if ($location.$$path.indexOf('admin') === -1) {
            $state.go('pub.profile');
        } else {
            $state.go('admin.profile');
        }
    }
  }

})();
